import AdminLeftSideBar from "./AdminLeftSideBar"
import AdminHeaderSection from "../component/AdminHeaderSection";
import { useSelector, useDispatch } from 'react-redux';

import adminUserImg from '../assets/images/profilePicDefault.png'
const AdminLayout = ({ children }) => {
    const showLeftSideBar = useSelector(state => state.adminToogle.adminToogleAction)
    return (
       <>
            <div className="adminHeader" >
                <div className={`adminHeaderContent ${showLeftSideBar ? '' : 'fullWidthMargin'}`}>
                    <AdminHeaderSection />
                </div>

            </div>
            {showLeftSideBar &&
                <div className={`adminSidebar ${showLeftSideBar ? 'fullWidthSectionLeft' : ''}`}>
                    <AdminLeftSideBar adminLogoUserName = 'Samrat Roy' adminLogoUserImg ={adminUserImg}/>
                </div>
            }
            <div className={`adminContent py-3 ${showLeftSideBar ? '' : 'fullWidthMargin'}`}>
                {children}
                
            </div>
        </>

    )
}

export default AdminLayout